import type { Category } from "./types";

/**
 * Menempatkan kategori pilihan menu yang mempunyai produk terlebih dahulu,
 * lalu kategori berproduk lain dalam urutan katalog, tanpa kartu duplikat.
 */
export function orderHomepageCategories(
  navigationCategories: Category[],
  productCategories: Category[],
): Category[] {
  const productCategoryKeys = new Set(
    productCategories.map((category) => String(category.id || category.slug)),
  );
  const seen = new Set<string>();
  return [
    ...navigationCategories.filter((category) =>
      productCategoryKeys.has(String(category.id || category.slug)),
    ),
    ...productCategories,
  ].filter((category) => {
    const key = String(category.id || category.slug);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
